import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LeavesMain from '../Main/LeavesMain';

function Leaves() {
  return (
    <Routes>
      <Route path="/" element={<LeavesMain />} />
      <Route path="*" element={<Navigate to="/leaves" replace />} />
    </Routes>
  );
}

export default Leaves;
